import _ from 'lodash'
import Generic from './generic'
import Region from './region'
import City from './city'

class School extends Generic {
  constructor({ region, city, ...attributes }) {
    super(attributes)

    this._region = region ? new Region(region) : null
    this._city = city ? new City(city) : null
  }

  get customCity() { return this.custom_city_name }

  get region() { return this._region }
  get city() { return this._city }

  get regionTitle() {
    if (!this.region) { return this.cityTitle }
    return this.region.isCity && this.city ? this.cityTitle : this.region.name
  }

  get cityTitle() {
    return this.city && this.city.name || this.customCity
  }

  get officialTitle() {
    return _.isEmpty(this.full_name) ? this.name : this.full_name
  }
}

export default School
